import Request from "./constants/Request.api"
import Response from "./constants/Response.api"

const BASE_URL = process.env.REACT_APP_BASE_URL
const OK_RESPONSES = [200, 201, 202, 203, 204, 205, 206, 207, 208, 209]
class Api {
  async getRequest(req) {
    let headers = {}
    if (req.data.token != null) {
      headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + JSON.parse(localStorage.getItem("authUser")).token,
      }
    } else {
      headers = { "Content-Type": "application/json" }
    }
    const requestOptions = {
      method: "GET",
      headers: headers,
    }
    //console.log(req)
    // console.log("URL = " + BASE_URL + req.data.url)
    try {
      const response = await fetch(BASE_URL + req.data.url, requestOptions).catch(error => {
        // console.log("error from api", error)
        return new Response({
          code: 500,
          message: "server error",
          status: false,
        })
      })

      const data = await response.json()
      if (OK_RESPONSES.includes(data.code)) {
        return new Response({ ...data, status: true })
      } else {
        return new Response({ ...data, message: data.error, status: false })
      }
    } catch (error) {
      //console.log(error)
      return new Response({ code: 500, message: "server error", status: false })
    }
  }

  async postRequest(req) {
    let headers = {}
    // console.log(req)

    if (req.data.token != null) {
      headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + JSON.parse(localStorage.getItem("authUser")).token,
      }
    } else {
      headers = { "Content-Type": "application/json" }
    }
    const requestOptions = {
      method: "POST",
      headers: headers,
      body: JSON.stringify(req.data),
    }

    try {
      const response = await fetch(
        BASE_URL + req.data.url,
        requestOptions
      ).catch(error => {
        
        console.log(error)
        return new Response({
          code: 500,
          message: "server error",
          status: false,
        })
      })
      // console.log("response-->", response)
      const data = await response.json()
      // console.log(data)

      if (OK_RESPONSES.includes(data.code)) {
        return new Response({ ...data, status: true })
      } else {
        // console.log(data)
        return new Response({ ...data, message: data.error, status: false })
      }
    } catch (error) {
      console.log(error)
      return new Response({ code: 500, message: "server error", status: false })
    }
  }

  async deleteRequest(req) {
    let headers = {}
    // console.log(req)

    if (req.data.token != null) {
      headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + JSON.parse(localStorage.getItem("authUser")).token,
      }
    } else {
      headers = { "Content-Type": "application/json" }
    }
    const requestOptions = {
      method: "DELETE",
      headers: headers,
      body: JSON.stringify(req.data),
    }

    try {
      const response = await fetch(
        BASE_URL + req.data.url,
        requestOptions
      ).catch(error => {
        
        console.log(error)
        return new Response({
          code: 500,
          message: "server error",
          status: false,
        })
      })
      // console.log("response-->", response)
      const data = await response.json()
      // console.log(data)

      if (OK_RESPONSES.includes(data.code)) {
        return new Response({ ...data, status: true })
      } else {
        // console.log(data)
        return new Response({ ...data, message: data.error, status: false })
      }
    } catch (error) {
      console.log(error)
      return new Response({ code: 500, message: "server error", status: false })
    }
  }

  async putRequest(req) {
    let headers = {}

    if (req.data.token != null) {
      headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + JSON.parse(localStorage.getItem("authUser")).token,
      }
    } else {
      headers = { "Content-Type": "application/json" }
    }
    const requestOptions = {
      method: "PUT",
      headers: headers,
      body: JSON.stringify(req.data),
    }

    // console.log("req data", req.data)

    try {
      const response = await fetch(
        BASE_URL + req.data.url,
        requestOptions
      ).catch(error => {
        console.log(error)
        return new Response({
          code: 500,
          message: "server error",
          status: false,
        })
      })
      const data = await response.json()

      if (OK_RESPONSES.includes(data.code)) {
        return new Response({ ...data, status: true })
      } else {
        return new Response({ ...data, message: data.error, status: false })
      }
    } catch (error) {
      return new Response({ code: 500, message: "server error", status: false })
    }
  }

  async uploadRequest(req) {
    let headers = {}

    if (req.data.token != null) {
      headers = {
        Accept: "application/x-www-form-urlencoded",
        Authorization: "Bearer " + JSON.parse(localStorage.getItem("authUser")).token,
      }
    } else {
      headers = { "Content-Type": "application/json" }
    }

    const requestOptions = {
      method: "POST",
      headers: headers,
      body: req.data.formData,
    }

    try {
      const response = await fetch(
        BASE_URL + req.data.url,
        requestOptions
      ).catch(error => {
        console.log(error)
        return new Response({
          code: 500,
          message: "server error",
          status: false,
        })
      })

      const data = await response.json()

      if (OK_RESPONSES.includes(data.code)) {
        return new Response({ ...data, status: true })
      } else {
        // console.log(data)
        return new Response({ ...data, message: data.error, status: false })
      }
    } catch (error) {
      console.log(error)
      return new Response({ code: 500, message: "server error", status: false })
    }
  }

  // This change was made in Nov 2025
  async downloadRequestBlob(req) {
  let headers = {};

  if (req.token !== null) {
    headers = {
      Authorization: req.data.token,
    };
  }

  const requestOptions = {
    method: "GET",
    headers: headers,
  };

  try {
    const response = await fetch(BASE_URL + req.data.url, requestOptions);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    // Convert directly to blob
    const blob = await response.blob();
    return blob;

  } catch (error) {
    console.error("Blob download error:", error);
    return null;
  }
}

  async downloadRequest(req) {
    let headers = {}

    if (req.data.token != null) {
      headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + JSON.parse(localStorage.getItem("authUser")).token,
      }
    } else {
      headers = { "Content-Type": "application/json" }
    }

    const requestOptions = {
      method: "GET",
      //headers: headers,
    }

    // console.log(req)

    try {
      const response = await fetch(BASE_URL + req.data.url).catch(error => {
        console.log(error)
        return new Response({
          code: 500,
          message: "server error",
          status: false,
        })
      })
      // console.log(response)

      return response
    } catch (error) {
      return new Response({ code: 500, message: "server error", status: false })
    }
  }
}

export default Api
